import { firestore as db } from "./firebase";
import { AuthenticatedUser } from "./users";

export const COLLECTION_COMMENT_LIKES: string = "comment_likes";

// The CommentLike type defines for a commentId which users liked it.
export type CommentLike = {
  likedBy: {
    userId: string;
    displayname: string;
  }[];
  comment: {
    commentId: string;
    userId: string;
  };
};

export async function getLikes(commentId: string): Promise<CommentLike | null> {
  const document = await db
    .collection(COLLECTION_COMMENT_LIKES)
    .doc(commentId)
    .get();

  let commentLike = null;
  if (document.exists) commentLike = document.data() as any;

  return commentLike;
}

export async function likeOrUnlikeComment(
  commentId: string,
  authorUserId: string,
  likedByUser: AuthenticatedUser,
  like: boolean
): Promise<boolean> {
  const commentLikeRef = db.collection(COLLECTION_COMMENT_LIKES).doc(commentId);

  try {
    await db.runTransaction(async (transaction: any) => {
      const commentLike = await transaction.get(commentLikeRef);

      if (commentLike.exists) {
        const data = commentLike.data();
        if (like) {
          transaction.update(commentLikeRef, {
            likedBy: [
              ...data.likedBy,
              { userId: likedByUser.id, displayname: likedByUser.displayname },
            ],
          });
        } else {
          transaction.update(commentLikeRef, {
            likedBy: data.likedBy.filter(
              (user: any) => user.userId !== likedByUser.id
            ),
          });
        }
      } else {
        if (like) {
          const newCommentLikeDocument = {
            comment: { commentId, userId: authorUserId },
            likedBy: [
              { userId: likedByUser.id, displayname: likedByUser.displayname },
            ],
          };
          transaction.set(commentLikeRef, newCommentLikeDocument);
        }
      }
    });
    return true;
  } catch (error) {
    return false;
  }
}
